import { Box } from '@mui/material';
import { CONSTANTS } from 'consts';
import { UserAppContext } from 'contexts';
import useGetCrmSessionHook from 'Hooks/CrmSessionHook';
import React, { useContext, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';
import { ENV } from 'scripts/environment';
import { CustomError, getExceptionFromError } from 'scripts/utils/handleErrors';
import { useConnectLogbookMutation } from 'services/crmServer';
import Swal from 'sweetalert2';
import { getUrlVars } from 'utils/url';

const Logbook = () => {
    const history = useHistory()
    const { auth } = useContext(UserAppContext);

    const [connectLogbook] = useConnectLogbookMutation();

    const { crmToken } = useGetCrmSessionHook();

    useEffect(() => {
        const params = getUrlVars();
        if (params && auth.crmUserId && params.code) {
            connectStravaIntoCRM(params)
        } else if (params && auth.crmUserId && !params.code) {
            Swal.fire("Error", "You didn't authenticate with Logbook", 'error').then(() => {
                history.push(CONSTANTS.NAVIGATION_URL.WORKOUT_HISTORY)
            })
        }
    }, [auth])

    const connectStravaIntoCRM = async (params: any) => {
        Swal.showLoading()
        try {
            const REDIRECT_URI: string = window.location.origin + ENV.LOGBOOK.REDIRECT_URL;
            await connectLogbook({
                variables: {
                    scope: "user:read,results:write",
                    code: params.code,
                    redirectUrl: REDIRECT_URI
                },
                context: {
                    clientName: "crm-server",
                    headers: {
                        "authorization": "Bearer " + crmToken
                    }
                }
            })
            await Swal.fire("Successfully Synced", "", 'success');
            history.push(CONSTANTS.NAVIGATION_URL.INTEGRATIONS)
            // askSyncAllWorkouts()
        } catch (err) {
            const errDetail = getExceptionFromError(err) as CustomError;
            if (errDetail && errDetail.key === "strava_has_connected") {
                await Swal.fire("Error", "This Logbook account has been connected with another Aviron account.", 'error')
            } else {
                await Swal.fire("Error", "Connect to Logbook failed", 'error')
            }
            history.push(CONSTANTS.NAVIGATION_URL.INTEGRATIONS)
        }
    }

    return <Box sx={{
        width: "fit-content",
        margin: "32px auto",
        textAlign: "center"
    }}>
        <Helmet>
            <meta charSet="utf-8" />
            <title>Logbook connect | Aviron</title>
            <link rel="canonical" href={window.location.href} />
        </Helmet>
        {/* <Typography mt="24px" mb="16px" variant="h4" component="h4">Logbook connecting...</Typography>
        <Typography mb="16px" variant="body1" component="p">We will sync workout to your Logbook account.</Typography> */}
    </Box>
}

export default Logbook;